import { useQuery } from '@tanstack/react-query';
import { getSlider } from '../../api/apiSliders';

export const useGetSlider = (id) => {
    return useQuery({
        queryKey: ['slider', id],
        queryFn: () => getSlider(id),
        enabled: !!id,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
};